import { useReactToPrint } from 'react-to-print';
import { RefObject } from 'react';

interface PrintOptions {
  landscape?: boolean;
  margins?: string;
}

export const usePagePrint = (
  contentRef: RefObject<HTMLElement>,
  options: PrintOptions = {}
) => {
  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    pageStyle: `
      @media print {  
        @page {
          size: ${options.landscape ? "A4 landscape" : "A4"};
          margin: ${options.margins ? options.margins : "1cm"};
        }
      }
    `
  });

  return handlePrint;
};
